<template>
  <div>
    <projects-table></projects-table>
  </div>
</template>

<script>
import ProjectsTable from "@/components/Projects/ProjectsTable";
export default {
    components: {
        ProjectsTable
    }
};
</script>